import { Item } from "baseui/side-navigation";
import { Key } from "react";
import { useRecoilValue } from "recoil";
import {
  CHILDREN_SETTINGS_PAGE_IDS,
  CORE_PAGE_IDS,
  SETTINGS_PAGE_ID,
  SETTINGS_PAGE_IDS,
} from "../constants/app";
import { pageState } from "../storage/app";
import { getPageNavKey } from "../utils/pages";

export function useSidenavItems(items: Item[]) {
  const currentPage = useRecoilValue(pageState);

  const coreItems = items.filter((item) =>
    item.itemId ? CORE_PAGE_IDS.includes(item.itemId) : false
  );
  const settingsItems = items.filter((item) =>
    item.itemId ? SETTINGS_PAGE_IDS.includes(item.itemId) : false
  );

  const pageSection: Key | undefined = (() => {
    const navKey = getPageNavKey(currentPage) ?? "";
    if (
      SETTINGS_PAGE_IDS.includes(navKey) ||
      CHILDREN_SETTINGS_PAGE_IDS.includes(navKey)
    ) {
      return SETTINGS_PAGE_ID;
    }
    return undefined;
  })();

  const sections: any[] = (() => {
    return [
      {
        id: SETTINGS_PAGE_ID,
        title: "Configuración",
        items: settingsItems,
      },
    ];
  })();

  return {
    pageSection,
    coreItems,
    sections,
  };
}
